// extracted by mini-css-extract-plugin
module.exports = {"alert":"hT","alertIcon":"hU","formContainer":"hV","formContainerInner":"hW","successIcon":"hX","footer":"hY","footerItem":"hZ"};